// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentNetStandardCaseDocumentRelationshipModel {
    static getAttributeTypeMap() {
        return EnrollmentNetStandardCaseDocumentRelationshipModel.attributeTypeMap;
    }
}
EnrollmentNetStandardCaseDocumentRelationshipModel.discriminator = undefined;
EnrollmentNetStandardCaseDocumentRelationshipModel.additionalProperties = false;
EnrollmentNetStandardCaseDocumentRelationshipModel.attributeTypeMap = [
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "comment",
        "baseName": "comment",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentNetStandardCaseDocumentRelationshipModel.js.map